export function isStandalone() {
  if (typeof window === 'undefined') {
    return false;
  }
  return (
    (typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true
  );
}

export function isAppHidden() {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden';
}

export function requestNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return Promise.resolve('unsupported');
  }
  if (Notification.permission === 'granted' || Notification.permission === 'denied') {
    return Promise.resolve(Notification.permission);
  }
  return Notification.requestPermission();
}

export function notify(title, options = {}) {
  if (typeof window === 'undefined' || !('Notification' in window) || Notification.permission !== 'granted') {
    return;
  }
  if (navigator.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'SHOW_NOTIFICATION', title, options });
    return;
  }
  try {
    new Notification(title, options);
  } catch (error) {
    console.warn('Unable to show notification', error);
  }
}